const equipment = (() => {
  if (document.querySelector("body#pageEquipment") !== null) {



    let sW = window.innerWidth;

    if (sW > 768) {

      let sec = document.querySelectorAll('.js-sec-cntnt');

      sec.forEach((element, index) => {

        let wrap = element.querySelector('.js-cntnt-wrap');
        let area = wrap.querySelector('.js-pin-area');
        let box = area.querySelector('.js-pin-box');

        // ピン
        let to = gsap.to(box, {
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: box,
            start: '50% 50%',
            endTrigger: element,
            end: '100% 100%',
            pin: true,
            pinSpacing: false,
            // markers: true,
          }
        });
        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            to.scrollTrigger.refresh()
            // console.log('comParallax refresh');
          });
        });
        observer.observe(target);

      });

    }



    let btns = document.querySelectorAll('.js-tab-btn');
    let outers = document.querySelectorAll('.js-sec-outer');

    btns.forEach((element, index) => {

      element.addEventListener('click', () => {

        outers.forEach(element2 => {
          element2.classList.remove('is-act');
        });

        if (index == 0 || index == 3) {
          outers[0].classList.add('is-act');
        }

        if (index == 1 || index == 4) {
          outers[1].classList.add('is-act');
        }

        if (index == 2 || index == 5) {
          outers[2].classList.add('is-act');
        }

      });

    });

    outers[0].classList.add('is-act');



  }
})()
export default equipment;